import { element } from '../../core/elements';
import { getPatternUrls, PatternCircles, PatternHexagons, PatternLines, PatternWaves } from '../patterns';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export const DEFAULT_A11Y_ORDINAL_COLORS = ["var(--ds-chart-categorical-1, #2898BD)", "var(--ds-chart-categorical-2, #5E4DB2)", "var(--ds-chart-categorical-3, #E56910)", "var(--ds-chart-categorical-4, #943D73)", "var(--ds-chart-categorical-5, #09326C)", "var(--ds-chart-categorical-6, #8F7EE7)", "var(--ds-chart-categorical-7, #50253F)", "var(--ds-chart-categorical-8, #A54800)"];
export const DEFAULT_STATUS_ORDINAL_COLORS = [{
  key: 'danger',
  value: "var(--ds-chart-danger, #F15B50)"
}, {
  key: 'warning',
  value: "var(--ds-chart-warning, #B38600)"
}, {
  key: 'success',
  value: "var(--ds-chart-success, #22A06B)"
}, {
  key: 'discovery',
  value: "var(--ds-chart-discovery, #8F7EE7)"
}, {
  key: 'information',
  value: "var(--ds-chart-information, #388BFF)"
}, {
  key: 'neutral',
  value: "var(--ds-chart-neutral, #8590A2)"
}];
export const DEFAULT_ORDINAL_COLORS = ["var(--ds-chart-brand, #2898BD)", "var(--ds-chart-orange-bold, #943D73)", "var(--ds-chart-magenta-bold, #E56910)", "var(--ds-chart-lime-bold, #5E4DB2)", "var(--ds-chart-purple-bold, #09326C)", "var(--ds-chart-teal-bold, #8F7EE7)", "var(--ds-chart-green-bold, #50253F)", "var(--ds-chart-blue-boldest, #A54800)"];
export const DEFAULT_ORDINAL_PATTERNS_DEFS = [/*#__PURE__*/_jsx(PatternLines, {
  id: "lines1",
  height: 5,
  width: 5,
  stroke: DEFAULT_ORDINAL_COLORS[0],
  strokeWidth: 1,
  orientation: ['diagonal']
}), /*#__PURE__*/_jsx(PatternCircles, {
  id: "circles1",
  height: 5,
  width: 5,
  radius: 1,
  stroke: DEFAULT_ORDINAL_COLORS[1],
  fill: DEFAULT_ORDINAL_COLORS[1]
}), /*#__PURE__*/_jsx(PatternHexagons, {
  id: "hexagons1",
  height: 3,
  size: 8,
  strokeWidth: 1,
  stroke: DEFAULT_ORDINAL_COLORS[2]
}), /*#__PURE__*/_jsx(PatternWaves, {
  id: "waves",
  height: 4,
  width: 4,
  stroke: DEFAULT_ORDINAL_COLORS[3],
  strokeWidth: 1
}), /*#__PURE__*/_jsx(PatternLines, {
  id: "lines2",
  height: 5,
  width: 5,
  stroke: DEFAULT_ORDINAL_COLORS[0],
  strokeWidth: 1
})];
export const DEFAULT_ORDINAL_PATTERNS = getPatternUrls(DEFAULT_ORDINAL_PATTERNS_DEFS);
export const useThemeFillStyles = _ref => {
  let {
    fillStyles
  } = _ref;
  if (!fillStyles) return {
    range: [],
    domain: []
  };
  if (fillStyles.filter(d => typeof d !== 'string').length > 0) {
    return {
      domain: fillStyles.map(d => typeof d === 'string' ? d : d.key),
      range: fillStyles.map(d => typeof d === 'string' ? d : d.value)
    };
  } else {
    return {
      range: fillStyles === null || fillStyles === void 0 ? void 0 : fillStyles.map(d => typeof d === 'string' ? d : d.value)
    };
  }
};

/** Public props */

export const Theme = element(_ref2 => {
  let {
    children
  } = _ref2;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
});
export const colorPalette = {
  accessibleCategorical: DEFAULT_A11Y_ORDINAL_COLORS,
  categorical: DEFAULT_ORDINAL_COLORS,
  status: DEFAULT_STATUS_ORDINAL_COLORS
};